module.exports = __webpack_public_path__ + "media/images/logo-vertical-51929d542976fb404f854a60070a3db1.svg";